<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import indowInsert from './images/Indow-close-up.jpg';
	import archedWindowIcon from './images/noun-arched-window-2601544-FFFFFF.svg';
	import noToolsIcon from './images/noun-no-tools-701248-FFFFFF.svg';
	import usaFlagIcon from './images/noun-usa-flag-5509212-FFFFFF.svg';
	import warrantyIcon from './images/noun-warranty-6913341-FFFFFF.svg';
</script>

<Section
	imageColumn={indowInsert}
	columnPosition="left"
	backgroundColor="blue"
	imageColumnClass="md:absolute max-md:hidden"
>
	<div class="max-w-prose">
		<h2 class="mb-10">The Indow Window Difference</h2>

		<ul class="text-indow-grey-dark list-none">
			<li class="max-xs:flex-col mb-8 flex flex-row items-center gap-8">
				<div class="w-full max-w-16 shrink-0">
					<Image src={archedWindowIcon} />
				</div>

				<div>
					<h3
						class="text-indow-grey-dark mb-0 text-left text-base font-bold normal-case"
					>
						Guaranteed To Fit
					</h3>
					<p class="text-indow-grey-dark">
						Your inserts are custom made to your exact window measurements with
						our proprietary compression tubing, ensuring a nearly airtight seal
						and backed by our
						<a class="text-black" href="/warranties/snug-fit-guarantee">
							Snug Fit Guarantee
						</a>.
					</p>
				</div>
			</li>

			<li class="max-xs:flex-col mb-8 flex flex-row items-center gap-8">
				<div class="w-full max-w-16 shrink-0">
					<Image src={warrantyIcon} />
				</div>
				<div>
					<h3
						class="text-indow-grey-dark mb-0 text-left text-base font-bold normal-case"
					>
						Quality Built For A Lifetime
					</h3>
					<p class="text-indow-grey-dark">
						Your inserts feature premium insulating acrylic that is built to
						withstand daily use and engineered to perform for the lifetime of
						your home. Guaranteed to be free from defect by our
						<a
							class="text-black"
							href="/warranties/residential-lifetime-warranty"
						>
							Lifetime Warranty
						</a>.
					</p>
				</div>
			</li>

			<li class="max-xs:flex-col mb-8 flex flex-row items-center gap-8">
				<div class="w-full max-w-16 shrink-0">
					<Image src={noToolsIcon} />
				</div>
				<div>
					<h3
						class="text-indow-grey-dark mb-0 text-left text-base font-bold normal-case"
					>
						Easy To Install & Remove
					</h3>
					<p class="text-indow-grey-dark">
						Installation is simple - no tools or modifications to your existing
						window frames are necessary. Simply slide them into place in seconds
						and experience immediate results.
					</p>
				</div>
			</li>

			<li class="max-xs:flex-col flex flex-row items-center gap-8">
				<div class="w-full max-w-16 shrink-0">
					<Image src={usaFlagIcon} />
				</div>
				<div>
					<h3
						class="text-indow-grey-dark mb-0 text-left text-base font-bold normal-case"
					>
						Handcrafted In The USA
					</h3>
					<p class="text-indow-grey-dark">
						Each insert is proudly handcrafted in our Portland, OR facility
						using materials sourced right here in the USA, which allows us to
						maintain rigorous quality control and meet our exacting standards.
					</p>
				</div>
			</li>
		</ul>
	</div>
</Section>
